/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_left_view .sp_minute').html(cutDownTimeText.minute)
      $('.sp_left_view .sp_second').html(cutDownTimeText.second)
    }, 1000)
  }

  getCutDownTime()

  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
  })

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  let _swiper = new Swiper('.sp-swiper-p1', {
    spaceBetween: 10,
    speed: 1,
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let _topHeight =
          $('.time-part').height() +
          $('.sp-header-top').height() +
          $('.sp-nav').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            _topHeight * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  $('.reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
      $('#price1').html(((window.product[0].price / 100) * num).toFixed(2) + '')
      $('#price2').html(
        ((window.product[0].compare_at_price / 100) * num).toFixed(2) + ''
      )
    }
  })
  $('.add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    $('#price1').html(((window.product[0].price / 100) * num).toFixed(2) + '')
    $('#price2').html(
      ((window.product[0].compare_at_price / 100) * num).toFixed(2) + ''
    )
  })

  $('.sp-btn-style').click(function () {
    let num = $(this).siblings('.addGroup').find('input').val()
    num == undefined ? (num = 1) : ''
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })

  $('.sp-part10 .sp-content').click(function () {
    const targetElement = document.getElementById('add-to-cart') // 获取跳转目标节点
    const offsetTop = targetElement.offsetTop + 55
    window.scroll({
      top: offsetTop * $('div#root').css('zoom'),
      behavior: 'smooth', // 使用 smooth 实现平滑滚动
    }) // 方式二
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }

  // 弹幕效果
  const dmRows = document.querySelectorAll('.sp-dm-row')

  dmRows.forEach(row => {
    // 计算每行的总宽度
    let totalWidth = 0
    row.childNodes.forEach(child => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        totalWidth +=
          child.offsetWidth +
          parseInt(window.getComputedStyle(child).marginRight, 10)
      }
    })

    // 设置动态动画持续时间以保持匀速移动
    const speed = 100 // 可以调整速度，数值越大，速度越慢
    const duration = totalWidth / speed
    row.style.animationDuration = `${duration}s`
    row.style.transition = `all ${duration}s`

    row.addEventListener('animationiteration', () => {
      setTimeout(() => {
        row.style.transform = 'translateX(0)'
      }, duration)
    })
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })
})
